import React, { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import axios from 'axios';
import { CheckCircle } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error('La contraseña debe tener al menos 6 caracteres');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      setDone(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error al restablecer contraseña');
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="min-h-screen bg-[#020402] flex items-center justify-center px-6 grid-overlay">
        <div className="w-full max-w-md glass-panel rounded-lg p-8 alien-glow text-center">
          <CheckCircle className="h-12 w-12 text-emerald-500 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-emerald-50 mb-3" style={{ fontFamily: 'Rajdhani, sans-serif' }}>CONTRASEÑA ACTUALIZADA</h2>
          <p className="text-emerald-100/70 mb-6">Tu contraseña ha sido restablecida exitosamente.</p>
          <Link to="/login"><Button className="w-full bg-emerald-500 text-black hover:bg-emerald-400 font-bold">Iniciar Sesión</Button></Link>
        </div>
      </div>
    );
  }

  if (!token) {
    return (
      <div className="min-h-screen bg-[#020402] flex items-center justify-center px-6 grid-overlay">
        <div className="w-full max-w-md glass-panel rounded-lg p-8 alien-glow text-center">
          <h2 className="text-2xl font-bold text-red-400 mb-3">ENLACE INVÁLIDO</h2>
          <p className="text-emerald-100/70 mb-6">Este enlace no es válido. Solicita uno nuevo.</p>
          <Link to="/login"><Button className="w-full bg-emerald-500 text-black hover:bg-emerald-400 font-bold">Volver al Login</Button></Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#020402] flex items-center justify-center px-6 grid-overlay">
      <div className="w-full max-w-md glass-panel rounded-lg p-8 alien-glow" data-testid="reset-password-form">
        <div className="flex justify-center mb-6">
          <img src="/logo.png" alt="Logo" className="w-14 h-14" />
        </div>
        <h2 className="text-2xl font-bold text-center text-emerald-50 mb-6" style={{ fontFamily: 'Rajdhani, sans-serif' }}>NUEVA CONTRASEÑA</h2>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <Label className="text-emerald-100">Nueva Contraseña</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} placeholder="Mínimo 6 caracteres" className="bg-black/50 border-emerald-500/30 text-emerald-50" data-testid="new-password-input" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-emerald-500 text-black hover:bg-emerald-400 font-bold py-6" data-testid="reset-submit-btn">
            {loading ? 'Cargando...' : 'Restablecer Contraseña'}
          </Button>
        </form>
      </div>
    </div>
  );
}
